function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

function freegift_item(){
  var cartContents = fetch('/cart.js')
      .then(response => response.json())
      .then(data => { 
    var free_gift_reduce_total = 20000;
      var cartItems = data.items,
      qtyInTheCart = 0,
      qtyInTheCart_price = 0,
      cartUpdates = [],
      gift_added = "",
      discounts_title ="",
      variant_id = 41811311329440,
      cartTotal = data.original_total_price;
    for (var i=0; i<cartItems.length; i++) {
      if (cartItems[i].id === variant_id ) {
        qtyInTheCart = cartItems[i].quantity;
        if(cartItems[i].discounts.length > 0){
        discounts_title = cartItems[i].discounts[0].title;          
        }
        qtyInTheCart_price = cartItems[i].final_price;
        console.log(cartItems[i]);
      }
    }
              
    var free_gift_reduce_totals = cartTotal - qtyInTheCart_price;

    if (( qtyInTheCart > 0 ) && (free_gift_reduce_totals < free_gift_reduce_total ) && (qtyInTheCart_price > 1)) {
        gift_added = "false";
    }else if (( cartItems.length > 0 ) && (free_gift_reduce_totals > free_gift_reduce_total)){
      if((qtyInTheCart > 0)){
        gift_added = "true";
        $("#cart-notification-product-"+variant_id).find(".price span").text("free");
      }
    }
  });
}

$("#Search-In-Modal").on("focus",function(){
  $(this).parents(".field").find(".search__button").hide();
  $(this).parents(".field").find(".field__label").hide();  
});
$("#Search-In-Modal").on("focusout",function(){
  var val = $(this).val();
  if(val ==""){
    $(this).parents(".field").find(".field__label").show();
    $(this).parents(".field").find(".search__button").show();
  }
});
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', 'false')

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
  })

  if (summary.closest('header-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ]
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', (event) => {
    mouseClick = true
  })

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused')

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add('focused')
    },
    true
  )
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => video.pause())
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)))
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

      if(this.input.max == this.input.value && event.target.name === 'plus' ){
        event.target.setAttribute("disabled",true);
        // event.target.setAttribute("disabled",false); 
      }else{
        // event.target.setAttribute("disabled",""); 
        $("button[name='plus']").removeAttr("disabled","");
      }    

      console.log("event.this_plus",previousValue,this.input.max)
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)          
  }
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid)

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector('details')

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)

    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    )
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    )
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const isOpen = detailsElement.hasAttribute('open')
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'))
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus)
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement)
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
        summaryElement.setAttribute('aria-expanded', true)
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus)
      }, 100)
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening')
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open')
        details.classList.remove('menu-opening')
      })
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
      removeTrapFocus(elementToFocus)
      this.closeAnimation(this.mainDetailsToggle)
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer()
    })
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening')
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false)
    removeTrapFocus()
    this.closeAnimation(detailsElement)
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'))
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header')
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    )

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })

    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this))
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide()
      })
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
      })
    }
  }

  show(opener) {
    this.openedBy = opener
    const popup = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector('button')

    if (!button) return
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'))
      if (modal) modal.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent() {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

      this.setAttribute('loaded', true)
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus()
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class SliderComponent extends HTMLElement {
  constructor() {
    super()
    this.slider = this.querySelector('ul')
    this.sliderItems = this.querySelectorAll('li')
    this.pageCount = this.querySelector('.slider-counter--current')
    this.pageTotal = this.querySelector('.slider-counter--total')
    this.prevButton = this.querySelector('button[name="previous"]')
    this.nextButton = this.querySelector('button[name="next"]')

    if (!this.slider || !this.nextButton) return

    const resizeObserver = new ResizeObserver((entries) => this.initPages())
    resizeObserver.observe(this.slider)

    this.slider.addEventListener('scroll', this.update.bind(this))
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this))
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this))
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0)
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1]
    if (sliderItemsToShow.length === 0) return
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth)
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1
    this.update()
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled')
    } else {
      this.prevButton.removeAttribute('disabled')
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled')
    } else {
      this.nextButton.removeAttribute('disabled')
    }

    this.pageCount.textContent = this.currentPage
    this.pageTotal.textContent = this.totalPages
  }

  onButtonClick(event) {
    event.preventDefault()
    const slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth
    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }
}

customElements.define('slider-component', SliderComponent)

class SliderCollectionList extends SliderComponent {
  constructor() {
    super()

    this.wrapper = document.querySelector('.collection-list-wrapper')
    this.wrapperWidth = this.wrapper.offsetWidth

    this.navPreviousButton = document.querySelector('button.slider-collection-list_nav-button[name="nav-previous"]')
    this.navNextButton = document.querySelector('button.slider-collection-list_nav-button[name="nav-next"]')

    this.posX = 0

    this.isDown = false
    this.startX = 0
    this.scrollLeft = 0

    this.slider.addEventListener('mousedown', (event) => {
      this.isDown = true
      this.slider.classList.add('active')
      this.startX = event.pageX - this.slider.offsetLeft
      this.scrollLeft = this.slider.scrollLeft
      console.log(this.startX, this.scrollLeft)
    })

    this.slider.addEventListener('mouseleave', () => {
      this.isDown = false
      this.slider.classList.remove('active')
    })

    this.slider.addEventListener('mouseup', () => {
      this.isDown = false
      this.slider.classList.remove('active')
    })

    this.slider.addEventListener('mousemove', (event) => {
      if (!this.isDown) return
      event.preventDefault()
      const x = event.pageX - this.slider.offsetLeft
      const walk = x - this.startX
      this.slider.scrollLeft = this.scrollLeft - walk
      console.log(walk)
    })

    this.navPreviousButton.addEventListener('click', () => {
      this.slider.scrollTo({
        top: 0,
        left: -this.wrapperWidth,
        behavior: 'smooth',
      })
      this.posX = this.slider.scrollLeft
    })

    this.navNextButton.addEventListener('click', () => {
      this.slider.scrollTo({
        top: 0,
        left: this.wrapperWidth,
        behavior: 'smooth',
      })

      this.posX = this.slider.scrollLeft
    })
  }

  onNavButtonClick(event) {
    console.log('hello')
  }
}

customElements.define('slider-collection-list', SliderCollectionList)

class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.removeErrorMessage()

    // setTimeout(function () {
    //   document.querySelector('#product_info_wrapper .price').classList.add('active')
    // }, 1600)
console.log("this.currentVariant",this.currentVariant);
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateShareUrl()
    }
  }

  updateOptions() {
    console.log("this.options=>",this.options);
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value)
    console.log(this.options)
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    )

    if (!newMedia) return
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`)
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`)
    const src = document
      .querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"] .product__media img`
      )
      .getAttribute('src')
    const srcset = document
      .querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"] .product__media img`
      )
      .getAttribute('srcset')
    document
      .querySelector('.product-media-main button.product__media-toggle')
      .setAttribute('data-media-id', this.currentVariant.featured_media.id)
    console.log("this.currentVariant.featured_media.id",this.currentVariant);
    $(`.product__media-list .product__media-item[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`).trigger("click");
    // document.querySelector('.product-media-main .product__media img').setAttribute('src', src)
    // document.querySelector('.product-media-main .product__media img').setAttribute('srcset', srcset)
    const parent = newMedia.parentElement
    if (parent.firstChild == newMedia) return
    modalContent.prepend(newMediaModal)
    parent.prepend(newMedia)
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header')
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'))
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0
      document.querySelector('.product-media-main').scrollIntoView({ behavior: 'smooth' })
    })
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton) return
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateVariantInput() {    
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`)
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      console.log("input=>",input)
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return
console.log("this.currentVariant.available",this.currentVariant.inventory_quantity);
      const form__noscript = document.querySelectorAll(`#Variants-${this.dataset.section}`)
      console.log("form__noscript",form__noscript);
      var selected = $(form__noscript).find(`option[value="${this.currentVariant.id}"]`).attr("max");
      // var maxx = $(selected).find('option[value="'+this.currentVariant.id+'"]').attr("max");
    console.log("maxx==>",selected);
    const quantity_block = document.querySelectorAll(`#Quantity-${this.dataset.section}`);
    console.log("quantity_block",quantity_block);
    $(quantity_block).attr("max",selected);
    
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage() {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove('visibility-hidden')
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`)
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')

    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute('disabled')
      addButtonText.textContent = window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`)
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const price = document.getElementById(`price-${this.dataset.section}`)
    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
    })
  }
}

customElements.define('variant-radios', VariantRadios)

// moved StickyHeader here
class StickyHeader extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.navItems = this.querySelectorAll('nav.desktop-menu li')
    this.subNav = document.querySelector('.header__sub-nav')

    this.subNavWrapper = this.querySelector('nav.desktop-menu ul')

    this.mainMenuParents = this.querySelectorAll('nav.desktop-menu > ul > li > a')

    this.subNavigationContainers = this.querySelectorAll('.desktop-menu__sub-navigation')

    window.addEventListener('load', (event) => {
      this.subNavigationContainers.forEach((item) => {
        item.style.top = `${document.querySelector('sticky-header').getBoundingClientRect().height}px`
      })
    })

    this.mainMenuParents.forEach((menu, currentIndex, listObj) => {
      menu.addEventListener('mouseenter', (event) => {
        const subNavigation = menu.parentNode.querySelector('.desktop-menu__sub-navigation')

        const subNavigationContainer = subNavigation.querySelector('ul')

        if (!subNavigationContainer.childNodes.length > 0) return

        listObj.forEach((item) => {
          item.parentNode.classList.remove('active')
        })

        event.target.parentNode.classList.add('active')

        subNavigation.addEventListener('mouseleave', (event) => {
          event.target.parentNode.classList.remove('active')
        })
      })
    })

    // this.headerBounds = {}
    // this.currentScrollTop = 0
    // this.preventReveal = false
    this.predictiveSearch = this.querySelector('predictive-search')
    this.statusSubNav = false

    // this.onScrollHandler = this.onScroll.bind(this)
    // this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

    // this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
    // window.addEventListener('scroll', this.onScrollHandler, false)

    // this.createObserver()

    // this.subNavWrapper.addEventListener('mouseenter', () => {
    //   if (!this.statusSubNav) {
    //     this.subNav.classList.remove('hidden')
    //     this.statusSubNav = true
    //   } else {
    //     this.subNav.classList.add('hidden')
    //     this.statusSubNav = false
    //   }
    // })

    // this.subNav.addEventListener('mouseleave', () => {
    //   this.subNav.classList.add('hidden')
    //   this.statusSubNav = false
    // })

    // setTimeout(() => {
    //   this.subNav.style.top = `${this.offsetHeight}px`
    // }, 66)
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect
      observer.disconnect()
    })

    observer.observe(this.header)
  }

  onScroll() {
    console.log('onScroll()')

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    console.log('SubNav Height: ', this.subNav.offsetHeight)

    console.log('scrollTop', scrollTop)

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom + this.subNav.offsetHeight) {
      requestAnimationFrame(this.hide.bind(this))
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom + this.subNav.offsetHeight) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this))
      } else {
        window.clearTimeout(this.isScrolling)

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false
        }, 66)

        requestAnimationFrame(this.hide.bind(this))
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this))
    }

    this.currentScrollTop = scrollTop
  }

  hide() {
    console.warn('hide()')
    // document.body.classList.add('overflow-hidden')
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
    this.closeMenuDisclosure()
    this.closeSearchModal()

    // document.body.classList.remove('overflow-hidden')

    // this.subNav.classList.add('h-0')
  }

  reveal() {
    console.warn('reveal')
    // document.body.classList.add('overflow-hidden')
    this.header.classList.add('shopify-section-header-sticky', 'animate')
    this.header.classList.remove('shopify-section-header-hidden')
    // document.body.classList.remove('overflow-hidden')
    // this.subNav.classList.remove('h-0')
  }

  reset() {
    // console.log('reset()')
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate')
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure')
    this.disclosures.forEach((disclosure) => disclosure.close())
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal')
    this.searchModal.close(false)
  }
}

customElements.define('sticky-header', StickyHeader)

function setFromPrice(element) {
  
  console.log(element);
  // var element = "#ProductGridContainer #product-grid li.grid__item";
  var checkExists = setInterval(function () {
    if ($(element).length) {
     
      clearInterval(checkExists)

      $(element).each(function (e) {
       
        let price = $(this).find('p.calculated-from-price').first()
        if (!price.length) return
        let arr = JSON.parse($(this).find('div[data-prices]').first().attr('data-prices'))
        let min = Math.min(...arr)
        let minMoney = min / 100
        let minMoneyFormat = parseFloat(minMoney).toFixed(2);
        let max = Math.max(...arr)
        let maxMoney = max / 100
        let maxMoneyFormat = parseFloat(maxMoney).toFixed(2);
        maxMoneyFormat = parseFloat(maxMoneyFormat);
        	// console.log("pr"+arr);
        	// console.log("max"+typeof maxMoneyFormat +"-"+maxMoney);
        	// console.log("min"+typeof parseFloat(minMoneyFormat)+"-"+minMoney);
        if(maxMoneyFormat > 0.01 && maxMoneyFormat > minMoneyFormat && minMoneyFormat > 0.01){
        $(this).find('p.calculated-from-price s').html('Was From £'+parseFloat(maxMoneyFormat).toFixed(2));
        }
        if(minMoneyFormat < 0.01 && maxMoneyFormat > minMoneyFormat && maxMoneyFormat > 0.01 ){
          $(this).find('p.calculated-now-price').html('Now From £'+parseFloat(maxMoneyFormat).toFixed(2));        
        }        
        if(minMoneyFormat > 0.01){
        $(this).find('p.calculated-now-price').html('Now From £'+parseFloat(minMoneyFormat).toFixed(2));
        }
      })
    }
  }, 100) // check every 100ms
}
